/**
 * Doomsworn — the Doom Die, the Doom Clock, and the declared Doom
 *
 * At creation every PC writes down their Doom in their own words: the end they
 * cannot avoid. On any roll they may add the Doom Die *after seeing the d20*.
 * It always helps. It never fails. Each use marks one segment of the clock, and
 * when the clock fills, the Doom arrives.
 *
 * The declared Doom is a first-class field the GM reads every scene.
 * Foreshadowing it is not flavour — it is the core loop.
 *
 * Engine authority: the clock is engine state. The narrator reports segments;
 * it never spends, refunds, or reinterprets them.
 */
/** Advancement grows the die: more power, and a faster arrival. */
export const DOOM_DIE_TRACK = ['d4', 'd6', 'd8', 'd10', 'd12'];
/** Segments in a Doom Clock. Fill it and your Doom arrives. */
export const DOOM_CLOCK_SEGMENTS = 8;
/** Wear accrues as the clock passes these thresholds. */
export const DOOM_CLOCK_WEAR_THRESHOLDS = [2, 4, 6, 8];
export function newDoomState(declared = '') {
    return { declared, die: 'd4', clock: 0, arrived: false };
}
export function doomDieSides(die) {
    return parseInt(die.slice(1), 10);
}
/** Step the die up one place on the track. Caps at d12. */
export function growDoomDie(die) {
    const i = DOOM_DIE_TRACK.indexOf(die);
    return DOOM_DIE_TRACK[Math.min(i + 1, DOOM_DIE_TRACK.length - 1)];
}
/**
 * Spend the Doom Die on a roll already made. `rng` is injectable so the engine
 * can keep spends deterministic and replayable.
 */
export function spendDoomDie(state, rng = Math.random) {
    const sides = doomDieSides(state.die);
    const bonus = Math.floor(rng() * sides) + 1;
    const clock = Math.min(DOOM_CLOCK_SEGMENTS, state.clock + 1);
    const arrived = clock >= DOOM_CLOCK_SEGMENTS;
    const wearGained = DOOM_CLOCK_WEAR_THRESHOLDS.includes(clock) ? 1 : 0;
    return {
        state: { ...state, clock, arrived },
        bonus,
        arrived,
        wearGained,
    };
}
/** How much road is left between here and the thing they already know is coming. */
export function segmentsRemaining(state) {
    return Math.max(0, DOOM_CLOCK_SEGMENTS - state.clock);
}
//# sourceMappingURL=doom.js.map